import React from "react";
import { cn } from "../utils";

// variant = "contained" | "outlined" | "text"
// type = "rounded" | "flat"
const Button = React.forwardRef(({
    startIcon,
    className,
    children,
    variant = "contained",
    buttonType="rounded",
    ...rest
}, ref)=> {
    return(
        <button
            ref={ref}
            className={cn("button-base py-2 d-flex justify-content-center align-items-center gap-2", variant, buttonType, className)}
            {...rest}
        >
            {startIcon ? startIcon : null}
            {children}
        </button>
    )
});

Button.displayName = "Button"

export default Button;